(function ($) {

  let lastScrollTop = 0;
  let currentScrollTop = 0;

  $(window).on("scroll", function () {
    currentScrollTop = $(this).scrollTop();

    const spacer = $(".pin-spacer").has("#site-header"); // le spacer contenant #site-header
    if (spacer.length && !spacer.hasClass("pin-spacer-site-header")) {
      spacer.addClass("pin-spacer-site-header");
    }

    if (currentScrollTop > 200) {
      $("#site-header").addClass("scrolling");
      spacer.addClass("scrolling");
    } else {
      $("#site-header").removeClass("scrolling");
      spacer.removeClass("scrolling");
    }

    // Menu mobile ouvert : on garde le header visible, sinon le panneau
    // (accroché sous le header) remonte avec lui et laisse un vide en bas.
    const mobileMenuOpen = $("#navigationMobile").hasClass("opened");

    if (!mobileMenuOpen && currentScrollTop > lastScrollTop && currentScrollTop > 100) {
      $("#site-header").addClass("scrolling-hide");
      spacer.addClass("scrolling-hide");
    } else {
      $("#site-header").removeClass("scrolling-hide");
      spacer.removeClass("scrolling-hide");
    }

    lastScrollTop = currentScrollTop;
  });

  b_menu_burger();
  function b_menu_burger() {
    $(".plus").on("click", function () {
      $(".menu-item-has-children").removeClass("open");
      $(this).parent().addClass("open");
    });
    $(".minus").on("click", function () {
      $(this).parent().removeClass("open");
    });
    $(".burger-class").on("click", function (e) {
      $(".menu-item-has-children").removeClass("open");
      $("#contentHeader").toggleClass("tadaa");
      $(".site-logo ").toggleClass("open");
      $(".top-navigation ").toggleClass("flex");

      $(this).toggleClass("opened");
      $("#page").toggleClass("menu-open");
    });

    // If click on menu-item, close menu
    $(".menu-item, .fixed-btns a").on("click", function () {
      $(".burger-class").removeClass("opened");
      $("#contentHeader").removeClass("tadaa");
      $(".site-logo ").removeClass("open");
      $(".top-navigation ").removeClass("flex");
      $("#page").removeClass("menu-open");
    });
  }

})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
//ScrollSmoother
  if (typeof gsap === 'undefined' || typeof ScrollSmoother === 'undefined') {
    console.error('GSAP or ScrollSmoother is not loaded.');
    return;
  }
})

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin)

ScrollSmoother.create({
  smooth: 1.8, // how long (in seconds) it takes to "catch up" to the native scroll position
  effects: true, // looks for data-speed and data-lag attributes on elements
  smoothTouch: 0.2, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
});

gsap.to("#site-header", {
  scrollTrigger: {
    trigger: "#site-header",
    start: "top top",
    end: () => document.body.scrollHeight + "px",
    markers: false,
    toggleActions: "play none none reverse",
    pin: true,
    pinSpacing: false,
    scrub: true,
    onEnter: self => {
      const pinSpacer = self.pin && self.pin.parentNode;
      if (pinSpacer && pinSpacer.classList.contains("pin-spacer")) {
        pinSpacer.classList.add("pin-spacer-site-header");
      }
    },
    onRefresh: self => {
      const pinSpacer = self.pin && self.pin.parentNode;
      if (pinSpacer && pinSpacer.classList.contains("pin-spacer")) {
        pinSpacer.classList.add("pin-spacer-site-header");
      }
    }
  },
  opacity: 1,
  marginTop: "0px",
  duration: 0.4,
});

// Ancres #
document.querySelectorAll('a[href*="#"]').forEach(link => {
  link.addEventListener('click', function(e) {
    const href = this.getAttribute('href');
    const match = href.match(/#(.+)$/);
    if (match) {
      const id = '#' + match[1];
      const target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        const header = document.querySelector('#site-header');
        const offset = header ? header.offsetHeight : 0;
        gsap.to(window, {
          duration: 1,
          scrollTo: { y: id, offsetY: offset },
          overwrite: 'auto'
        });
      }
    }
  });
});
window.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    if (window.location.hash) {
      const id = window.location.hash;
      const target = document.querySelector(id);
      if (target) {
        const header = document.querySelector('#site-header');
        const offset = header ? header.offsetHeight : 0;
        gsap.to(window, {
          duration: 1,
          scrollTo: { y: id, offsetY: offset },
          overwrite: 'auto'
        });
      }
    }
  }, 100);
});
